module.exports = __webpack_public_path__ + "onboarding-feed-teamcity.76b31bada515a43fdef2323ee4b1cb99.hashedasset.svg";